__turbopack_context__.v({
  "checkIcon": "themeToggle-module-scss-module__xstDkW__checkIcon",
  "container": "themeToggle-module-scss-module__xstDkW__container",
  "divider": "themeToggle-module-scss-module__xstDkW__divider",
  "menu": "themeToggle-module-scss-module__xstDkW__menu",
  "menuItem": "themeToggle-module-scss-module__xstDkW__menuItem",
  "menuItemActive": "themeToggle-module-scss-module__xstDkW__menuItemActive",
  "menuItemLabel": "themeToggle-module-scss-module__xstDkW__menuItemLabel",
  "menuItemText": "themeToggle-module-scss-module__xstDkW__menuItemText",
  "themeIcon": "themeToggle-module-scss-module__xstDkW__themeIcon",
  "trigger": "themeToggle-module-scss-module__xstDkW__trigger",
  "triggerSmall": "themeToggle-module-scss-module__xstDkW__triggerSmall",
});
